import {useCallback, useState} from "react";
import ApiServiceV2 from "../services/ApiServiceV2";
import {AxiosError, AxiosResponse} from "axios";
import {routes} from "./routes";

export const useFetchSingle = <DataType>(
    url: keyof typeof routes,
    id?: number|string,
    onFulfill?: (response: AxiosResponse<any>) => void,
    onReject?: (error: AxiosError) => void,
) => {
    //states to fetch and store fonts
    const [data, setData] = useState<DataType|null>(null)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [error, setError] = useState<string|null>(null)

    //api call
    const handleFetchData = useCallback( (id?: string|number ) => {
        const api = new ApiServiceV2()
        setIsLoading(true)
        setError(null)

        const dataUrl = (id) ? routes[url] + '/' + id : routes[url]

        api.callApi(dataUrl).then((response: AxiosResponse<any>) => {
            if (response.data?.data) {
                setData(response.data.data)
            }
            if (onFulfill) onFulfill(response)
        }).catch((error: AxiosError) => {
            if (onReject) onReject(error)
            setError('['+error.response?.status+']: '+ error.message)
        }).finally(() => {
            setIsLoading(false)
        })
    }, [url, onFulfill, onReject])

    return {
        data,
        isLoading,
        error,
        fetch: handleFetchData
    }
}
